module.exports = __webpack_public_path__ + "static/img/img_logo.5e135d7d.png";